// extracted by mini-css-extract-plugin
export default {"container":"styles_container__mzsn6","wrapper-main":"styles_wrapper-main__-8BiF"};